import React, { useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = null, 
  cancelText = null,
  danger = false 
}) => {
  const { t } = useLanguage();

  useEffect(() => {
    if (!isOpen) return;

    // ESC key handler
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscKey);

    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">
            <AlertTriangle size={24} className={danger ? 'text-danger' : 'text-warning'} />
            <h2>{title || t('confirm', 'Confirm')}</h2>
          </div>
          <button onClick={onClose} className="modal-close">
            <X size={20} />
          </button>
        </div>

        <div className="modal-body">
          <p className="confirm-message">{message}</p>
        </div>

        <div className="modal-footer">
          <button 
            onClick={onClose} 
            className="btn-secondary"
          >
            {cancelText || t('cancel', 'Cancel')}
          </button>
          <button 
            onClick={handleConfirm} 
            className={danger ? "btn-danger" : "btn-primary"}
          >
            {confirmText || t('confirm', 'Confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
